import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PopupConfirm } from '../PopupConfirm';
import { OVER_18_KEY } from '@constants';
import { useData } from '@hooks/useData';
import { saveToSessionStorage } from '@utils/storage';
import { useUpdateUserAge } from '@services/useUpdateUserAge';

interface Over18ModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    setUserAgeAllowed: (value: boolean) => void;
}

export const Over18Modal: FC<Over18ModalProps> = ({ show, setShow, setUserAgeAllowed }) => {
    const { request: requestUpdateUserAge, error: errorUpdateUserAge, lastResponseTime } = useUpdateUserAge();
    const { login } = useData();
    const { t } = useTranslation();

    const translations = {
        question: t('over-18-modal-component.question'),
        confirmation: t('over-18-modal-component.confirmation'),
        no: t('over-18-modal-component.no'),
        yes: t('over-18-modal-component.yes'),
    };

    const handleIsMinor = () => {
        setShow(false);
        saveToSessionStorage<string>(OVER_18_KEY, 'false');
        setUserAgeAllowed(false);
    };

    const handleConfirmOver18 = () => {
        if (login !== null) {
            // user is logged in, update its age with API
            requestUpdateUserAge({ over_18: true });
        } else {
            setShow(false);
            saveToSessionStorage<string>(OVER_18_KEY, 'true');
            setUserAgeAllowed(true);
        }
    };

    // if created account successfully, go to login page
    // if not, show error
    useEffect(() => {
        if (lastResponseTime && !errorUpdateUserAge) {
            setShow(false);
            saveToSessionStorage<string>(OVER_18_KEY, 'true');
            setUserAgeAllowed(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastResponseTime]);

    return (
        <PopupConfirm
            show={show}
            onHide={handleIsMinor} // on 'x'
            question={translations.question}
            confirmation={translations.confirmation}
            cancelButtonText={translations.no}
            confirmButtonText={translations.yes}
            onClickCancel={handleIsMinor}
            onClickConfirm={handleConfirmOver18}
        />
    );
};
